import React from 'react';
import PropTypes from 'prop-types';

const ReplayPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M14.72 1.281l-4.013 4.012a1 1 0 0 0 0 1.414l4.013 4.013a.75.75 0 0 0 1.28-.53V8a9 9 0 1 1-8.945 8H7a1 1 0 0 0-1-1H4a1 1 0 0 0-.977 1.215c-.015.26-.023.521-.023.785 0 7.179 5.82 13 13 13s13-5.821 13-13S23.18 4 16 4V1.811a.75.75 0 0 0-1.28-.53z"
    />
  );
};

ReplayPath.propTypes = {
  fill: PropTypes.string,
};

export default ReplayPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/replay.jsx